module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"top_movies":"Top Movies"},"ja":{"top_movies":"スタッフおすすめ"}}')
  delete Component.options._Ctor
}
